import _ from 'lodash'

const endSubscriptionErrorPaymentRefused = {
    bindings: {
        contract: '<',
    },
    template: require('./endSubscriptionErrorPaymentRefused.jade')(),
    /** @ngInject */ controller(MailAdresses, ContactTelephone, ContractDraft, ErrorCatcher) {
        const ctrl = this
        ctrl.MailAdresses = MailAdresses
        ctrl.contactTelephone = ContactTelephone.anonymous

        ctrl.goToPayment = () => {
            let getPaymentIframePromise
            if (_.isEmpty(localStorage.subscriptionToken)) {
                getPaymentIframePromise = ContractDraft.getPaymentIframe({ id: ctrl.contract.id }).$promise
            } else {
                getPaymentIframePromise = ContractDraft.getPaymentIframeByToken({ id: ctrl.contract.id, token: localStorage.subscriptionToken }).$promise
            }
            getPaymentIframePromise.then((response) => {
                window.location = response.redirectUrl
            })
            .catch((error) => {
                ErrorCatcher.catchError(error)
            })
        }
    },
}

export default endSubscriptionErrorPaymentRefused



// WEBPACK FOOTER //
// ./src/states/endSubscription/component/endSubscriptionErrorPaymentRefused.js